function DarkerMailIcon() {
	return (
		<svg
			width="22"
			height="22"
			viewBox="0 0 22 22"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M2.39038 5.17756C1.83301 6.35779 1.83301 8.04288 1.83301 11C1.83301 14.4373 1.83301 16.1559 2.70835 17.3607C2.99104 17.7498 3.33322 18.092 3.72233 18.3747C4.92713 19.25 6.64575 19.25 10.083 19.25H11.9163C15.3536 19.25 17.0722 19.25 18.277 18.3747C18.6661 18.092 19.0083 17.7498 19.291 17.3607C20.1663 16.1559 20.1663 14.4373 20.1663 11C20.1663 8.02198 20.1663 6.33403 19.5971 5.15261M2.39038 5.17756C2.48088 4.98593 2.58607 4.80761 2.70835 4.63932C2.99104 4.25022 3.33322 3.90804 3.72233 3.62534C4.92713 2.75 6.64575 2.75 10.083 2.75H11.9163C15.3536 2.75 17.0722 2.75 18.277 3.62534C18.6661 3.90804 19.0083 4.25022 19.291 4.63932C19.408 4.80029 19.5093 4.97042 19.5971 5.15261M2.39038 5.17756L2.74967 5.5L4.51786 7.26819C7.57342 10.3237 9.1012 11.8515 10.9997 11.8515C12.8982 11.8515 14.4259 10.3237 17.4815 7.26819L19.2497 5.5L19.5971 5.15261"
				stroke="#2E7FDB"
				strokeWidth="1.5"
			/>
		</svg>
	);
}

export default DarkerMailIcon;
